import * as React from 'react';
import * as RX from 'reactxp';

class Html extends React.Component<{ html: string }> {

  constructor(props: { html: string }) {
    super(props);
  }

  public render() {
    return (
      <div style={{ color: 'white' }} dangerouslySetInnerHTML={{ __html: this.props.html}}/>
    );
  }
}

export default Html;



// WEBPACK FOOTER //
// ./src/modules/html/index.web.tsx